import type { MeasureComponentProps, MeasureComponentState } from "@component/MeasureComponent";
import { MeasureComponent } from "@component/MeasureComponent";
import type { EventComponentType } from "@utils/google-analytics-4.type";
import autobind from "autobind-decorator";
import { LazyLoad, PromisePool, focusOnFirstElement } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import { reactLazyShortcode } from "shortcode-helper";
import type { QuestionLead, SelectThemeDropdown } from "../QuestionLead/QuestionLead";

const QuestionLeadComponent = reactLazyShortcode<typeof QuestionLead>("question_lead");

interface Props extends MeasureComponentProps {
	onShow?(show: boolean): void;
}

interface State extends MeasureComponentState {
	showModal: boolean;
	showButton: boolean;
	askUsTheme: SelectThemeDropdown;
}

export class AskUs extends MeasureComponent<Props, State> {
	private static defaultState: Partial<State> = {};
	private readonly promisePool = new PromisePool();
	protected productTypes = "MORTGAGE,PERSONAL_LOAN,SME_ACCOUNT,BUILDING_SOCIETY,DEPOSIT,CREDIT_CARD";
	protected readonly componentType: EventComponentType = "widget";

	protected getInitialState(): State {
		return {
			...super.getInitialState(),
			showModal: false,
			showButton: false,
			askUsTheme: undefined,
			...AskUs.defaultState,
		};
	}

	public componentDidMount(): void {
		super.componentDidMount();
		this.setState(AskUs.defaultState as State);

		this.addListeners();
	}

	private addListeners(): void {
		document
			.querySelectorAll('a[href="#askUsModal"],button[href="#askUsModal"],div[data-target="#askUsModal"]')
			.forEach((button) => {
				button.addEventListener("click", this.onToggleModal);
			});
	}

	public componentWillUnmount(): void {
		this.promisePool.cancel();
	}

	public render(): ReactNode {
		const { showModal, askUsTheme } = this.state;

		if (!showModal) {
			return null;
		}

		return (
			<Modal
				className="modal-success"
				centered
				show={showModal}
				onEnter={focusOnFirstElement}
				onHide={this.onToggleModal}
			>
				<Modal.Header closeButton>
					<Modal.Title className="text-center w-100">Kérj INGYENES szakértői segítséget!</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<LazyLoad>
						<QuestionLeadComponent theme={askUsTheme} />
					</LazyLoad>
				</Modal.Body>
			</Modal>
		);
	}

	@autobind
	private onToggleModal() {
		const { onShow } = this.props;
		const { showModal } = this.state;
		const toggleValue = !showModal;

		if (onShow) {
			onShow(toggleValue);
		}

		this.setState({
			showModal: toggleValue,
		});
	}

	protected getComponentName(): string {
		return "AskUs";
	}
}
